/*-----------------------------------------------------------------
- Contact translations
-----------------------------------------------------------------*/
export default {
    title        : 'تماس با ما',
    contact_title: 'اطلاعات تماس',
    map          : 'فروشگاه بانمک را روی نقشه پیدا کنید',

    comments: {
        form    : 'پیام خود را ثبت کنید',
        list    : 'دیدگاه کاربران',
        subtitle: 'در صورت نیاز پیام خود را از طریق فرم زیر برای ما ارسال کنید',
    },
};
